/*
 * @Author: Hank 
 * @Date: 2024-09-18 17:53:12 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2024-11-13 15:44:16
 */

<template>
  <div
    ref="zjdgx"
    class="new-advertiser"
  >
    <div class="bread-crumb">
      Advertisers<span
        class="current"
      >{{ id ? 'Edit' : 'New' }} Affiliate</span>
    </div>
    <h2>{{ id ? 'Edit' : 'New' }} Affiliate</h2>
    <a-spin :spinning="loading">
      <div class="content">
        <a-steps
          style="width: 400px;margin: 30px auto;margin-bottom: 50px;"
          :current="1"
          :items="[
            {
              title: 'Advertiser',
            },
            {
              title: 'Affiliate',
            },
          ]"
          @change="() => router.replace(`/advertiser/edit/${id}`)"
        />
        <div class="advertiser-name">
          <div class="traffic-allocation" v-if="list.length > 0">
            <span class="traffic-label">Traffic Allocation</span>
            <a-switch v-model:checked="trafficAllocationEnabled" @change="onToggleTrafficAllocation" />
            <a-button
              size="small"
              @click="onEditTrafficAllocation"
              :disabled="!trafficAllocationEnabled"
            >
              Edit
            </a-button>
          </div>
          <p>{{ advertiserName }}</p>
        </div>
        <div
          v-for="(item, index) in list"
          :key="index"
        >
          <Detail
            v-if="!item.edit"
            :id="id"
            :item="item" 
            :on-edit="() => onEdit(index)" 
            :on-show-log-modal="() => onShowLogModal(item.id)"
            :allow-add="allowAdd"
            :on-flod="() => onFlod(index)"
          />
          <Form
            v-else 
            :id="id" 
            :item="item" 
            :allow-delete="item.id && (!item.deleteForbidden) && list.length > 1"
            :on-cancel="(id) => onCancel(index, id)"
            :on-complete="(res)=>onComplete(index, res)"
            :on-delete="() => onDelete(index)"
          />
        </div>
        <div
          v-if="allowAdd"
          style="margin-top: 30px;width: 100%;text-align: center;margin-bottom: 50px;"
        >
          <a-button
            type="dashed"
            style="width: 400px;font-weight: 500;"
            @click="addAffiliate"
          >
            <PlusOutlined />
            Add New Affiliate
          </a-button>
        </div>
      </div>
    </a-spin>
    <LogModal
      v-if="showLogModal"
      :id="id"
      :container="$refs.zjdgx"
      :show-affiliate-log-id="showAffiliateLogId"
      @hideLogModal="hideLogModal"
    />
    <TrafficAllocationModal
      v-if="showTrafficModal"
      :advertiser-id="id"
      :affiliates="activeAffiliates"
      :allocations="trafficAllocations"
      @cancel="hideTrafficModal"
      @save="onSaveTrafficAllocation"
    />
    <a-modal
      v-model:open="showTrafficNoticeModal"
      title="Notice"
      :footer="null"
      @cancel="showTrafficNoticeModal = false"
    >
      <p>Please save traffic allocation percentage first.</p>
      <a
        class="save-now-link"
        @click="onSaveNowFromNotice"
      >Save now.</a>
    </a-modal>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { message } from 'ant-design-vue'
import { advertiser } from '../../server/index'
import { useRoute, useRouter } from 'vue-router'
import Form from '../Affiliate/form';
import Detail from '../Affiliate/detail';
import LogModal from '../../components/logModal.vue'
import TrafficAllocationModal from '../../components/trafficAllocationModal.vue'
import {
  PlusOutlined,
} from '@ant-design/icons-vue'

const route = useRoute()
const router = useRouter()

const list = ref([])
const allowAdd = ref(true);
const loading = ref(false);

const id = route.params.id

const relationId = route.query.id

const showAffiliateLogId = ref(null);

const showLogModal = ref(false);

const advertiserName = ref('');

const trafficAllocationEnabled = ref(false);
const showTrafficModal = ref(false);
const showTrafficNoticeModal = ref(false);
const trafficAllocations = ref({});



const activeAffiliates = computed(() => {
  return list.value
});

const onEditTrafficAllocation = () => {
  showTrafficModal.value = true;
}

const hideTrafficModal = () => {
  showTrafficModal.value = false;
}

const onSaveTrafficAllocation = () => {
  loading.value = true;
  getAffiliateList();
  showTrafficModal.value = false;
  trafficAllocationEnabled.value = true;
}

const onEdit = (index) => {
    list.value[index].edit = true;
    allowAdd.value = false;
}

const onFlod = (index) => {
    list.value[index].flod = !list.value[index].flod ;
}

const onCancel = (index, id) => {
    if (id) {
        list.value[index].edit = false;
    } else {
        list.value.splice(index, 1);
    }
    allowAdd.value = true;
}

const onShowLogModal = (id) => {
    showAffiliateLogId.value = id;
    showLogModal.value = true;
}

const hideLogModal = () => {
    showLogModal.value = false;
}
const onSaveNowFromNotice = () => {
  showTrafficNoticeModal.value = false;
  showTrafficModal.value = true;
}

const onToggleTrafficAllocation = (checked) => {
  advertiser.toggleTrafficAllocation({
    advertiserId: id,
    enabled: checked
  }).then(res => {

    if (res.success) {
      trafficAllocationConfig.value.enabled = checked;
    } else {
      trafficAllocationEnabled.value = !checked;
      showTrafficNoticeModal.value = true;
    }
  })
}
const onComplete = (index, res) => {
  allowAdd.value = true;
  loading.value = true;
  getAffiliateList({ unfoldId: res.id });
}

const onDelete = (index) => {
    list.value.splice(index, 1);
    allowAdd.value = true;
}

const addAffiliate = () => {
    list.value.push({
        edit: true
    });
    allowAdd.value = false;
}
const trafficAllocationConfig = ref({
  enabled: false,
  items: [],
  advertiserId:""
});

const getAffiliateList = (options = {}) => {
  const { unfoldId } = options;
  advertiser.getAffiliateListById(id).then((res) => {
    if (res.success) {
      list.value = (res.data || []).map((item) => ({
        ...item,
        edit: false,
        flod: false,
      }))
      if (list.value.length === 0) {
        addAffiliate()
      }
      advertiser.getTrafficAllocationConfig(id).then((resTrafficAllocation) => {
        if (resTrafficAllocation.success) {
          trafficAllocationConfig.value = resTrafficAllocation.data || {}
          trafficAllocationEnabled.value = !!resTrafficAllocation.data?.enabled
          const items = trafficAllocationConfig.value.items || []
          list.value.forEach((item) => {
            item.percent =
              items.find(
                (item1) => item1.advertiserAffiliateRelationId === item.id
              )?.percent || 0
          })
        }
      })

      if (unfoldId) {
        const item = list.value.find((i) => i.id === unfoldId)
        if (item) {
          item.flod = true
        }
      } else if (relationId) {
        const index = list.value.findIndex(
          (item) => item.affiliateId == relationId
        )
        if (index !== -1) {
          const [targetObject] = list.value.splice(index, 1)
          list.value.unshift(targetObject)
          list.value[0].edit = true
          allowAdd.value = false
        }
      } else {
        if (list.value[0]?.status == 'active') {
          list.value[0].flod = true
        }
      }
      loading.value = false
    } else {
      message.error(res.error)
      loading.value = false
    }
  })
}

const init = () => {
  if (id) {
    loading.value = true;
    advertiser.getAdvertiserName(id).then(res => {
      if (res.success) {
        advertiserName.value = res.data.advertiserName;
      }
    })
    getAffiliateList()
  } else {
    addAffiliate();
  }
}

init()
</script>

<style lang="less" scoped>
.content {
  padding: 20px 60px;
  margin-bottom: 20px;
  .max-w {
    max-width: 320px;
  }
}

.advertiser-name {
  width: 100%;
  display: flex;
 
  justify-content: center;
  align-items: center;

  .traffic-allocation {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    .traffic-label {
      font-size: 14px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.88);
    }
  }
  p {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    text-align: left;
    flex: 1;
  }
}

.save-now-link {
  color: #1677ff;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
</style>
